import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = () =>
  createStyles({
    disabledIcon: {
      color: '#BEC0C1',
    },
    chipRoot: {
      position: 'fixed',
      backgroundColor: '#fff',
      zIndex: 1,
      padding: 0,
      borderRadius: '0 50px 50px 0',
    },
  });

export type Styles = WithStyles<typeof styles>;
